import React from 'react';
import { SHADCN, R, TYPO, FS } from '../theme';

// ── <SegmentedControl> — onglets in-page (style nav "TopBar") ────────────────
// Pas de piste : segment actif sur fond sidebarAccent, inactif transparent.
// tabs : [{ id, label, count?, Icon? }]  ·  size : 'sm' (6/10) | 'md' (7/12)

const SIZES = {
  sm: { padding: '6px 10px', minHeight: 32 },
  md: { padding: '7px 12px', minHeight: 34 },
};

export default function SegmentedControl({ tabs, value, onChange, size = 'md', style }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap', ...style }}>
      {tabs.map((t) => {
        const active = value === t.id;
        const Ic = t.Icon;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            data-sonore-btn=""
            style={{
              fontFamily: SHADCN.font, fontSize: FS.body, fontWeight: active ? 500 : 400, lineHeight: 1.4,
              display: 'flex', alignItems: 'center', gap: 7, whiteSpace: 'nowrap',
              background: active ? SHADCN.sidebarAccent : 'transparent',
              border: '1px solid transparent', borderRadius: R.md,
              padding: s.padding, minHeight: s.minHeight,
              color: active ? SHADCN.fg : SHADCN.mutedFg, cursor: 'pointer',
              transition: `color ${SHADCN.durFast} ${SHADCN.easeOut}, background ${SHADCN.durFast} ${SHADCN.easeOut}`,
            }}
            onMouseEnter={(e) => { if (!active) { e.currentTarget.style.color = SHADCN.fg; e.currentTarget.style.background = SHADCN.sidebarAccent; } }}
            onMouseLeave={(e) => { if (!active) { e.currentTarget.style.color = SHADCN.mutedFg; e.currentTarget.style.background = 'transparent'; } }}
          >
            {Ic && <Ic size={14} strokeWidth={1.7} />}
            {t.label}
            {t.count != null && (
              <span style={{ ...TYPO.num, fontSize: FS.caption, color: SHADCN.mutedFg, marginLeft: 2 }}>({t.count})</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
